import { CycleUtils } from '@wix/package-picker-shared';
import { useCurrentModule } from '../components/ModuleProvider';
import { useCycleAvailability } from './useCycleAvailability';
import { useCycleDefaultDecision } from './useCycleDefaultDecision';
export const useSelectedCycle = () => {
  const module = useCurrentModule();
  const selectedCycle = module.SDK.PackagePickerStore.useSelectedCycle();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const {
    isCycleAvailable,
    lowestCycleAvailable,
    isLoading: isCycleAvailabilityLoading
  } = useCycleAvailability(selectedProductId || undefined, selectedCycle || undefined);
  const {
    presetCycle,
    isLoading
  } = useCycleDefaultDecision();
  if (!isLoading && (!selectedCycle || !isCycleAvailable && !isCycleAvailabilityLoading)) {
    const cycle = CycleUtils.maxCycle([lowestCycleAvailable, presetCycle]);
    module.SDK.PackagePickerStore.setSelectedCycleId(CycleUtils.convertCycleToCycleId(cycle || presetCycle));
    return cycle;
  }
  return selectedCycle || undefined;
};
//# sourceMappingURL=useSelectedCycle.js.map